// extracted by mini-css-extract-plugin
module.exports = {"avatarDefault":"Avatar-module__avatarDefault___GbVYk"};